/** Writable / API-facing advance modes. */
export const MEDIA_PLAYLIST_ADVANCE_MODES = ['advance', 'show_info', 'skip', 'return_previous'] as const;

export type MediaPlaylistAdvanceMode = (typeof MEDIA_PLAYLIST_ADVANCE_MODES)[number];

/** Legacy values that may still appear in API responses after coercion. */
export const STORED_MEDIA_PLAYLIST_ADVANCE_MODES = [
  'repeat',
  'advance',
  'show_info',
  'skip',
  'return_previous',
] as const;

export type StoredMediaPlaylistAdvanceMode = (typeof STORED_MEDIA_PLAYLIST_ADVANCE_MODES)[number];

export const DEFAULT_MEDIA_PLAYLIST_ADVANCE_MODE: MediaPlaylistAdvanceMode = 'advance';
